import React from 'react';
import { Button, Modal, Space, TextHeading, useModalContext, } from '@ally/metronome-ui';
import { CallUsBlock } from '../Components/LoginShared';
import { useFlagContextValue } from '../FlagContext';
const headingRef = React.createRef();
const ModalContent = ({ shouldShowAllLOBs, }) => {
    const { variation } = useFlagContextValue();
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, { mb: "md" },
            React.createElement(TextHeading, { tag: "h1", size: "md", tabIndex: -1, ref: headingRef }, "Give us a call.")),
        React.createElement(Space, { mb: "md" },
            React.createElement(CallUsBlock, { shouldShowAllLOBs: shouldShowAllLOBs, variation: variation }))));
};
const ModalTriggerComponent = ({ triggerContent, }) => {
    const { setOpen } = useModalContext();
    return (React.createElement(Button, { allytmln: "callUs", variant: "link", text: triggerContent, onClick: () => setOpen(true) }));
};
export const CallUsModal = ({ disableTrigger = false, shouldShowAllLOBs = false, triggerContent = 'call', initialOpen = false, onOpenChange, }) => (React.createElement(Modal, Object.assign({ content: React.createElement(ModalContent, { shouldShowAllLOBs: shouldShowAllLOBs }), trigger: disableTrigger ? undefined : (React.createElement(ModalTriggerComponent, { triggerContent: triggerContent })), initialOpen: initialOpen }, (onOpenChange ? { onOpenChange } : {}))));
//# sourceMappingURL=CallUsModal.js.map